import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import cn from 'classnames';
import isUndefined from 'lodash/isUndefined';

import Input from './Input';

import styles from './index.styl';

const RadioInput = ({ vertical, ...other }) => (
  <label
    htmlFor={other.id}
    styleName={cn('label', {
      labelVertical: vertical,
    })}
  >
    <If condition={!isUndefined(other.label)}>
      <span styleName="labelText">{other.label}</span>
    </If>
    <Input {...other} />
  </label>
);

RadioInput.propTypes = {
  vertical: PropTypes.bool,
};

RadioInput.defaultProps = {
  vertical: null,
};

export default CSSModules(RadioInput, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/RadioInput/index.jsx